module.exports = __webpack_public_path__ + "static/media/specification.f9603dff.md";